import React, { useRef } from 'react';
import {
  FontIcon,
  mergeStyles,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';

const iconClass = mergeStyles({
  fontSize: '18',
  color: '#666666',
  margin: '13px',
});

const ChoosePicture = ({
  minWidth,
  maxFileSize,
  minAspectRatio,
  maxAspectRatio,
  isUploading,
  onUploadFile,
  allowedFileExtensions,
}) => {
  const { t: translator } = useTranslation();
  minWidth = minWidth ?? 700;
  minAspectRatio = minAspectRatio ?? 1.8;
  maxAspectRatio = maxAspectRatio ?? 3.5;
  allowedFileExtensions =
    allowedFileExtensions && Array.isArray(allowedFileExtensions)
      ? allowedFileExtensions
      : [];
  // calculating bytes to megabytes
  const maxFileSizeInMb = maxFileSize / Math.pow(10, 6);

  const onUploadFileLocal = (event) =>
    event.target.files.length && onUploadFile(event);

  const labelRef = useRef(null);
  const onKeyDownLabel = (event) => {
    if (event.key === 'Enter' && labelRef.current) {
      event.preventDefault();
      labelRef.current.click();
    }
  };

  return (
    <div className="choose-picture">
      <div className="choose-picture-box">
        <div className="choose-picture-box-left">
          <FontIcon iconName="PhotoCollection" className={iconClass} />
          {translator('components.fileComponents.choosePicture')}
        </div>
        <div>
          <label tabIndex="0" ref={labelRef} onKeyDown={onKeyDownLabel}>
            <FontIcon iconName="CirclePlus" className="choose-picture-icon" />
            <input
              id="upload-file-input"
              type="file"
              onChange={onUploadFileLocal}
              accept="image/*"
            />
          </label>
        </div>
      </div>
      <div className="choose-picture-text">
        {translator('components.fileComponents.choosePictureMinimumWidth')}:{' '}
        {minWidth} px
        <br />
        {translator('components.fileComponents.maxFileSize')}: {maxFileSizeInMb}{' '}
        MB
        <br />
        {translator('components.fileComponents.choosePictureAspectRatio')}:{' '}
        {minAspectRatio}:1 - {maxAspectRatio}:1
        {allowedFileExtensions.length ? (
          <>
            <br />
            {translator(
              'components.fileComponents.choosePictureAllowedFileTypes',
            )}
            : {allowedFileExtensions.join(' ')}
          </>
        ) : null}
      </div>
      {isUploading ? (
        <div className="choose-picture-spinner">
          <Spinner size={SpinnerSize.large} />
        </div>
      ) : null}
    </div>
  );
};

export { ChoosePicture };
